var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.realtimeLogsShow
    ? _c("div", { staticClass: "popup" }, [
        !_vm.aimsMoresFlag
          ? _c(
              "div",
              {
                staticClass: "content",
                style: {
                  height:
                    _vm.nonFlag &&
                    (_vm.viewDetail.tasks[0].status == "Run" ||
                      _vm.viewDetail.tasks[0].status == "Init")
                      ? "250Px"
                      : ""
                },
                attrs: { id: "viewRealTimeLogs" }
              },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("language.popup.taskListPopup.viewLogs")) +
                      "\n           "
                  ),
                  _c("div", {
                    staticClass: "icon white-close dialog-close",
                    on: {
                      click: function($event) {
                        return _vm.closePage()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.loading
                  ? _c("div", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "realTimeBody"
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "realTimeBody",
                        style: {
                          height:
                            _vm.nonFlag &&
                            (_vm.viewDetail.tasks[0].status == "Run" ||
                              _vm.viewDetail.tasks[0].status == "Init")
                              ? "210Px"
                              : ""
                        }
                      },
                      [
                        _vm.nonFlag
                          ? _c("div", { staticClass: "detail_txt" }, [
                              _vm.nonFlag &&
                              (_vm.viewDetail.tasks[0].status == "Run" ||
                                _vm.viewDetail.tasks[0].status == "Init")
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sync_detail",
                                        staticStyle: { color: "#000" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.common.syncDetails"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "log-line",
                                        staticStyle: { "margin-bottom": "3px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "view-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("language.common.sync")
                                              ) + ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "log-category-link",
                                            attrs: {
                                              title: _vm._f("getCatalogTitle")(
                                                _vm._f("getCatalog")(
                                                  _vm.viewDetail.tasks[0]
                                                    .fromItem.nodes
                                                )
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.toSourceCatalog(
                                                  _vm.viewDetail.tasks[0]
                                                    .fromItem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("getCatalog")(
                                                  _vm.viewDetail.tasks[0]
                                                    .fromItem.nodes
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "log-line" }, [
                                      _c("div", { staticClass: "view-name" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.with")
                                          ) + ": "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "log-category-link",
                                          attrs: {
                                            title: _vm._f("getCatalogTitle")(
                                              _vm._f("getCatalog")(
                                                _vm.viewDetail.tasks[0].toItem
                                                  .nodes
                                              )
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toAimCatalog(
                                                _vm.viewDetail.tasks[0].toItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("getCatalog")(
                                                _vm.viewDetail.tasks[0].toItem
                                                  .nodes
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          float: "left",
                                          "margin-top": "10px",
                                          height: "15px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudSync.initSync"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nonFlag &&
                              (_vm.viewDetail.tasks[0].status == "Stop" ||
                                _vm.viewDetail.tasks[0].status == "InitStop")
                                ? _c(
                                    "span",
                                    { staticStyle: { fontSize: "16Px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.taskNotRun")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nonFlag &&
                              _vm.viewDetail.tasks[0].status == "Normal"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        fontSize: "16Px",
                                        "margin-top": "30px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.common.taskNotRun")
                                        ) + " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#6f7886",
                                  lineHeight: "18Px",
                                  width: "100%",
                                  height: "50Px",
                                  marginBottom: "15Px"
                                }
                              },
                              _vm._l(
                                _vm.viewDetail.tasks[0].lastLog.newLog,
                                function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "logs-realTime-box progress-box-height",
                                      class: _vm.getHeight(item, index),
                                      staticStyle: { width: "100%" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "view-logs-realTime-info",
                                          staticStyle: { width: "100%" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "startTime-format",
                                              attrs: {
                                                title: _vm.getStartTile(item)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                         " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.common.startTime"
                                                    )
                                                  ) +
                                                  ":" +
                                                  _vm._s(
                                                    item.taskStartTimeStr
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "startTime-format",
                                              staticStyle: {
                                                marginLeft: "5px"
                                              },
                                              attrs: {
                                                title: _vm.getEndTile(item)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.common.endTime"
                                                    )
                                                  ) +
                                                  ":" +
                                                  _vm._s(item.lastSyncTime) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "task-item-status" },
                                            [
                                              item.response == "success"
                                                ? _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "language.common.success"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "icon-util task-success logs-failure-icon-position"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "show-status",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "language.common.success"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.common.success"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.response == "error"
                                                ? _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "language.common.failure"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "icon-util task-failure logs-failure-icon-position"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "show-status",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "language.common.failure"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.common.failure"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.response == "cancel"
                                                ? _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        title: _vm.$t(
                                                          "language.common.cancel"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "icon-util task-failure logs-failure-icon-position"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "show-status",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "language.common.cancel"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "language.common.cancel"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "icon-util  view-collapse-positopn",
                                            class:
                                              _vm.clickCurrent == index
                                                ? "collapse-up"
                                                : "collapse-down",
                                            on: {
                                              click: function($event) {
                                                return _vm.collapse(index, item)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("viewlogsDetail", {
                                            ref: "viewlogsDetail",
                                            refInFor: true,
                                            attrs: {
                                              clickCurrent: _vm.clickCurrent,
                                              index: index,
                                              itemDetail: item,
                                              allItem: _vm.viewDetail.tasks[0],
                                              isShow: true
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                      ]
                    ),
                _vm._v(" "),
                _vm.maxShow
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          bottom: "10px",
                          color: "red",
                          width: "508px",
                          "margin-left": "15px"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          },
                          mouseover: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.cloudSync.reachMax")))]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.aimsMoresFlag
          ? _c(
              "div",
              { staticClass: "content", attrs: { id: "viewLogsRealTime2" } },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("language.popup.taskListPopup.viewLogs")) +
                      "\n        "
                  ),
                  _c("div", {
                    staticClass: "icon white-close dialog-close",
                    on: { click: _vm.closePage }
                  })
                ]),
                _vm._v(" "),
                _vm.loading
                  ? _c("div", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "view-logs-body"
                    })
                  : _c("div", { staticClass: "view-reallogs-all" }, [
                      _vm.nonFlag && _vm.viewDetail.tasks[0].status == "Normal"
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                fontSize: "16Px",
                                "margin-top": "40px",
                                color: "#6f7886",
                                "margin-left": "15px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.taskNotRun")) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "view-logs-body" },
                            [
                              _vm._l(
                                _vm.viewDetail.tasks[0].lastLog.newLog,
                                function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "logs-realTime-box progress-box-height",
                                      class: _vm.getHeight(item, index),
                                      staticStyle: { width: "580px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "view-logs-realTime-info",
                                          staticStyle: { width: "100%" }
                                        },
                                        [
                                          _vm.viewDetail.tasks[0].lastLog &&
                                          _vm.viewDetail.tasks[0].lastLog.newLog
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "startTime-format",
                                                  attrs: {
                                                    title: _vm.getStartTile(
                                                      item
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                         " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "language.common.startTime"
                                                        )
                                                      ) +
                                                      ":" +
                                                      _vm._s(
                                                        item.taskStartTimeStr
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "startTime-format",
                                              staticStyle: {
                                                marginLeft: "5px"
                                              },
                                              attrs: {
                                                title: _vm.getEndTile(
                                                  _vm.getLastSyncTime(
                                                    item,
                                                    index
                                                  )
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "language.common.endTime"
                                                    )
                                                  ) +
                                                  ":" +
                                                  _vm._s(
                                                    _vm.getLastSyncTime(
                                                      item,
                                                      index
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "task-item-status" },
                                            [
                                              _vm.showStatus(index) == "success"
                                                ? _c("div", [
                                                    _c("div", {
                                                      staticClass:
                                                        "icon-util task-success logs-failure-icon-position"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          float: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "language.common.success"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showStatus(index) == "failure"
                                                ? _c("div", [
                                                    _c("div", {
                                                      staticClass:
                                                        "icon-util task-failure logs-failure-icon-position"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          float: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "language.common.failure"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showStatus(index) == "patial"
                                                ? _c("div", [
                                                    _c("div", {
                                                      staticClass:
                                                        "icon-util task-patial logs-status-icon-position"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          "line-height": "40Px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "language.common.patial"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showStatus(index) == "cancel"
                                                ? _c("div", [
                                                    _c("div", {
                                                      staticClass:
                                                        "icon-util task-failure logs-status-icon-position"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          "line-height": "42Px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "language.common.canceled"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div"),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "icon-util  view-collapse-positopn",
                                            class:
                                              _vm.clickCurrent == index
                                                ? "collapse-up"
                                                : "collapse-down",
                                            on: {
                                              click: function($event) {
                                                return _vm.collapse(index, item)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("viewSyncLogsDetail", {
                                            ref: "viewSyncLogsDetail",
                                            refInFor: true,
                                            attrs: {
                                              viewCurrent: _vm.clickCurrent,
                                              viewIndex: index,
                                              viewTask: _vm.viewDetail.tasks
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.show()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bottom-show",
                                      class:
                                        _vm.$i18n.locale == "deutsch"
                                          ? "desh-show"
                                          : "desh-not-show"
                                    },
                                    [
                                      _vm._v(
                                        "\n                 " +
                                          _vm._s(
                                            _vm.$t(
                                              "language.cloudSync.reachMax"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                    ])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21f809af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f809af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/view_realtime_logs_popups.vue
// module id = null
// module chunks = 